module.exports = __webpack_public_path__ + "static/media/revenueupload.ae13f241.png";